import { PageTypeSuffix } from '@/constants'
import type { Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface BlogCardType {
  post: Post
  imageWidth?: number
  imageHeight?: number
}
export const BlogCard = ({
  post,
  imageWidth = 400,
  imageHeight = 226,
}: BlogCardType) => {
  return (
    <div className='cursor-pointer'>
      <Link
        href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
          PageTypeSuffix.POST
        }`}
        className='relative mb-2 block overflow-hidden rounded pt-[56.25%]'
      >
        <ImageOptimize
          width={imageWidth}
          height={imageHeight}
          className='absolute left-0 top-0 block h-full w-full object-cover'
          alt={getTranslate(post?.title) || ''}
          src={post?.images[0]}
          thumbnail
        />
      </Link>

      <div>
        <Link
          href={`/${getTranslate(post.slugs.value)}${post.slugs.postfix}${
            PageTypeSuffix.POST
          }`}
          className='line-clamp-2 overflow-hidden text-base leading-[21px] text-dark-400'
        >
          {getTranslate(post.title)}
        </Link>
      </div>
    </div>
  )
}

export default BlogCard
